import { createStore, applyMiddleware, combineReducers } from 'redux';
import thunkMiddleware from 'redux-thunk';

import { cartReducer } from 'modules/Cart';
import { catalogReducer } from 'modules/Catalog';
import { animationsReducer } from 'components/ProductItem';

// Reducers
const rootReducer = combineReducers({
    cartReducer,
    catalogReducer,
    animationsReducer
});

export default () =>
    createStore(
        rootReducer,
        window.__REDUX_DEVTOOLS_EXTENSION__ &&
            window.__REDUX_DEVTOOLS_EXTENSION__(),
        applyMiddleware(thunkMiddleware)
    );



// WEBPACK FOOTER //
// ./src/store/store.js